import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemText } from '@mui/material';
import { Solution } from '../models/Issue';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface AccordianSolutionComponentProps {
    solution: Solution;
    index: number;
}

const AccordianSolutionComponent: React.FC<AccordianSolutionComponentProps> = ({ solution, index }) => {
    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="body2">Solution {index + 1}</Typography>
                    <Typography variant="body1">{solution.SolutionDescription}</Typography>
                    <Typography 
                        variant="body2" 
                        color="textSecondary" 
                        sx={{ mt: 1, fontSize: 15, fontWeight: 'bold' }}
                    >
                        Difficulty: {solution.Difficulty}/10
                    </Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <Box key={index} sx={{ mb: 2 }}>                    
                    <Typography variant="body1">Tools Needed</Typography>
                    <List>
                        {solution.Equipment?.map((item, equipmentIndex) => (
                            <ListItem key={equipmentIndex}>
                                <ListItemText primary={item} />
                            </ListItem>
                        ))}
                    </List>
                    
                    <Typography variant="body1" sx={{ mt: 2 }}>Steps</Typography>
                    <List>
                        {solution.Steps?.map((step, stepIndex) => (
                            <ListItem key={stepIndex}>
                                <ListItemText primary={`${stepIndex + 1}. ${step}`} />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};

export default AccordianSolutionComponent;
